function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Field, Form } from 'react-final-form';
import { Button, Card, CardContent, CardActions, TextField, Typography, CircularProgress } from '@material-ui/core';
import DoneRoundedIcon from '@material-ui/icons/DoneRounded';
import { useStyles } from "./styles.js";
export const ContactForm = ({
  onSubmit,
  validate,
  title,
  subtitle,
  emailLabel,
  messageLabel,
  submitButtonLabel,
  retryButtonLabel,
  elevation,
  aosProps,
  loading,
  error,
  sended
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    validate: validate,
    render: ({
      handleSubmit,
      submitting,
      errors
    }) => /*#__PURE__*/React.createElement("form", _extends({}, aosProps, {
      onSubmit: handleSubmit,
      className: classes.form
    }), /*#__PURE__*/React.createElement(Card, {
      elevation: elevation
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
      color: "secondary",
      variant: "h4",
      align: "left",
      gutterBottom: true
    }, title), /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      gutterBottom: true
    }, subtitle), /*#__PURE__*/React.createElement(Field, {
      name: "email",
      type: "email",
      render: ({
        input,
        meta
      }) => /*#__PURE__*/React.createElement(TextField, _extends({}, input, {
        variant: "outlined",
        margin: "normal",
        label: emailLabel,
        error: meta.touched && meta.error,
        helperText: meta.touched && meta.error,
        required: true,
        fullWidth: true
      }))
    }), /*#__PURE__*/React.createElement(Field, {
      name: "message",
      render: ({
        input,
        meta
      }) => /*#__PURE__*/React.createElement(TextField, _extends({}, input, {
        className: classes.messageField,
        rowsMax: "4",
        rows: "6",
        variant: "outlined",
        label: messageLabel,
        error: meta.touched && meta.error,
        helperText: meta.touched && meta.error,
        required: true,
        fullWidth: true,
        multiline: true
      }))
    })), /*#__PURE__*/React.createElement(CardActions, {
      className: classes.cardActions
    }, error && !loading && /*#__PURE__*/React.createElement(Typography, {
      align: "left",
      className: classes.error
    }, "Something went wrong \uD83E\uDD37. Please try again"), /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      color: "primary",
      variant: "outlined",
      className: classes.submitBtn,
      disabled: submitting || Object.keys(errors).length > 0
    }, error ? retryButtonLabel : loading ? /*#__PURE__*/React.createElement(CircularProgress, {
      size: 24
    }) : sended ? /*#__PURE__*/React.createElement(DoneRoundedIcon, null) : submitButtonLabel))))
  });
};
ContactForm.defaultProps = {
  elevation: 0,
  aosProps: {
    'data-aos': 'fade-up',
    'data-aos-once': 'true'
  },
  retryButtonLabel: 'retry'
};
ContactForm.displayName = 'ContactForm';
export default ContactForm;